import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';
import { get } from 'lodash';

import TextInput from 'common/TextInput';

const baseString = 'vra-seed-product-selector-rm-inputs';
const classString = classNames({
  [`${baseString}`]: true
});
const SeedProductSelectorRm = ({
  onChangeRm,
  rmValues,
  validationResult
}) => {
  const rmMaxValidationResult = get(validationResult, 'resultsByKey.rmMax');
  const rmMaxClassString = classNames({
    [`${baseString}__rmMin`]: true
  });

  const rmMinValidationResult = get(validationResult, 'resultsByKey.rmMin');
  const rmMinClassString = classNames({
    [`${baseString}__rmMin`]: true
  });

  return (
    <section className={classString}>
      <TextInput
        className={rmMinClassString}
        dataTestId='vra-hybrid-selector-rm__input-min'
        defaultValue={rmValues[0]}
        onBlur={(e) => onChangeRm(e.target.value, 'rmMin')}
        size='3'
        validationResult={rmMinValidationResult}
      />
      <span>{getMessage('to')}</span>
      <TextInput
        className={rmMaxClassString}
        dataTestId='vra-hybrid-selector-rm__input-max'
        defaultValue={rmValues[1]}
        onBlur={(e) => onChangeRm(e.target.value, 'rmMax')}
        size='3'
        validationResult={rmMaxValidationResult}
      />
    </section>
  );
};
SeedProductSelectorRm.propTypes = {
  onChangeRm: PropTypes.func.isRequired,
  rmValues: PropTypes.array.isRequired,
  validationResult: PropTypes.object // Can't have .isRequired because passing undefined is valid.
};
export default SeedProductSelectorRm;
